import { createContext } from 'react';

export type CompanyWorkspaceContextValue = {
  companyType?: string;
  toggleUpload?: () => void;
};

const CompanyWorkspaceContext = createContext<CompanyWorkspaceContextValue>({
  companyType: undefined,
  toggleUpload: undefined,
});

export default CompanyWorkspaceContext;
